var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-date-picker",
    _vm._b(
      {
        class: { isView: _vm.mode !== "edit" },
        attrs: {
          value: _vm.inputVal,
          type: _vm.rangeType,
          "value-format": _vm.valueformat,
          "default-time": _vm.defaultTime,
          "start-placeholder": _vm.placeholderStartTxt,
          "end-placeholder": _vm.placeholderEndTxt,
          clearable: "",
          disabled: _vm.isDisabled,
          "picker-options": _vm.pickerOptions,
        },
        on: { input: _vm.onChange, change: _vm.onChange },
      },
      "el-date-picker",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }